module.exports = __webpack_public_path__ + "static/media/5 1 Leseforstaelse Intro.b903e9a6.mp3";